import html2canvas from "html2canvas-pro";
import { jsPDF } from "jspdf";

export async function exportQuotePdf(elementId: string, filename: string) {
	const element = document.getElementById(elementId);
	if (!element) {
		throw new Error("Quote preview element not found");
	}

	const canvas = await html2canvas(element, {
		scale: 2,
		useCORS: true,
		backgroundColor: "#ffffff",
		logging: false,
	});

	const imgData = canvas.toDataURL("image/png");
	const imgWidth = 210; // A4 width in mm
	const pageHeight = 297; // A4 height in mm
	const imgHeight = (canvas.height * imgWidth) / canvas.width;

	const pdf = new jsPDF("p", "mm", "a4");
	let heightLeft = imgHeight;
	let position = 0;

	pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
	heightLeft -= pageHeight;

	while (heightLeft > 0) {
		position = -(imgHeight - heightLeft);
		pdf.addPage();
		pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
		heightLeft -= pageHeight;
	}

	pdf.save(`${filename}.pdf`);
}
